<template>
  <div class="page-wrapper">
    <the-email-header />

    <div class="center-content">
      <v-loader v-if="loader" />
      <h4 v-else class="text-center">{{ message }}</h4>
    </div>
  </div>
</template>

<script setup name="TheEmailAcceptTemplate">
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import api from "@/api";
import VLoader from "@/components/vendor/loader/VLoader.vue";
import TheEmailHeader from "@/components/email/TheEmailHeader.vue";

const route = useRoute();
const loader = ref(false);
const message = ref("");

const accept = async () => {
  const { caseid, token, resources } = route.query;
  console.log("__data", caseid, token, resources);
  loader.value = true;
  try {
    const resourceIds = typeof resources === "string" ? resources.split(",").map(Number) : [];

    const payload = {
      resourceIds,
    };
    const res = await api.case.acceptEmail(caseid, token, payload);
    message.value = res.message;
  } catch (error) {
    console.error(error);
    message.value = error?.response?.data?.message || "Error accepting email";
  } finally {
    loader.value = false;
  }
};

onMounted(() => {
  const { lang } = route.query;
  if (lang) {
    localStorage.setItem("language", lang);
  }
  accept();
});
</script>

<style>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.center-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
